export const LOADING_JOB_POSITION_RELATED = "LOADING_JOB_POSITION_RELATED";
export const SAVE_LOADING_JOB_POSITION_RELATED = "SAVE_LOADING_JOB_POSITION_RELATED";
export const GET_JOB_POSITION_RELATED = "GET_JOB_POSITION_RELATED";
export const FORM_FAIL = "FORM_FAIL";
export const JOB_POSITION_RELATED_FAIL = "JOB_POSITION_RELATED_FAIL";
export const LOADING_JOB_POSITION_RELATED_BY_ID = "LOADING_JOB_POSITION_RELATED_BY_ID";
export const GET_JOB_POSITION_RELATED_BY_ID = "GET_JOB_POSITION_RELATED_BY_ID";

